import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet";

import NavbarFixed from "../components/NavbarFixed";
import Footer from "../components/Footer";
import "../assets/fonts/fonts.css";
import img from "../assets/images/extras.png";
import ScrollDown from "../components/ScrollDown";

export default function Extras() {
  const [extrasTextOpacity, setExtrasTextOpacity] = useState(1);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const fadePoint = window.innerHeight / 2;

      if (scrollPosition >= fadePoint) {
        setExtrasTextOpacity(0); // Fade out
      } else {
        setExtrasTextOpacity(1); // Fade in
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div>
      <Helmet>
        <title>moses.zhang.extras</title>
      </Helmet>
      <NavbarFixed visible={true} />
      {/* Section 1: Static Background */}
      <section className="relative h-screen bg-fixed bg-black bg-opacity-100 bg-center bg-cover z-[-2]">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 2 }}
          className="fixed inset-0 flex justify-center items-center z-[-1]"
          style={{
            backgroundImage: `url(${img})`,
            backgroundSize: "cover", // Optional: to cover the entire div
            backgroundPosition: "center", // Optional: to center the image
            backgroundColor: "rgba(0,0,0,0.4)",
            backgroundBlendMode: "darken",
          }}
        >
          <motion.h1
            initial={{ opacity: 1 }}
            animate={{ opacity: extrasTextOpacity }} // Bind opacity to the scroll
            className="text-white text-6xl font-bold"
          >
            Extras
          </motion.h1>
        </motion.div>
      </section>

      <ScrollDown delay={0.6} />

      <motion.section
        className="h-screen bg-black bg-opacity-90 flex justify-center items-center border-y-2 border-neutral-700"
        initial={{ opacity: 0, y: 100 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <motion.div
          className="w-1/3 h-1/3 bg-red-500 flex justify-center items-center text-white text-xl rounded-md"
          whileHover={{ scale: 1.07 }}
          transition={{ type: "spring", stiffness: 100, mass: 0.5 }}
        >
          This page is under construction.
        </motion.div>
      </motion.section>
      <Footer />
    </div>
  );
}
